<section id="seedMange" class="sec_seed">
  <div class="container mat-elevation-z8 py-3">

    <div class=" seed-container">
      <app-seed-table title_page="Standard Keywords" [clients]="clients" [clientsstore]="clients"  [data]="dataFOrSeedDealers" [reason]="fordeal"></app-seed-table>
    </div>
</div>
</section>
